export default "__VITE_ASSET__BzQfDSGG__"